import { RssFeeds } from '@commercetools-docs/ui-kit';
import * as React from 'react';
export default {
  RssFeeds,
  React
};